export default __webpack_public_path__ + "./image/4f22719b0e741f0e497d2277d5b013ac.png";